export default "__VITE_ASSET__Bej$MM9N__"